module.exports = __webpack_public_path__ + "img/sent.68c72f35.svg";